import { cn } from '@/src/utils/styles'

interface SpinnerProps {
  className?: string
}

export const Spinner = (props: SpinnerProps) => {
  return (
    <div
      className={cn(
        'inline-block h-5 w-5 animate-[spin_0.7s_linear_infinite] rounded-full border-2 border-current border-b-transparent',
        props?.className,
      )}
    >
      <span className='sr-only'>Loading...</span>
    </div>
  )
}
